import { ModalProps } from '../../hooks/useDialog';
import { SKIN } from '../../types/enums';

const BET365_COMMON_MODAL_PROPS: ModalProps = {
  anchor: 'bottom',
  maxWidth: 'xs',
  fullWidth: true,
  slotProps: {
    paper: {
      sx: {
        backgroundColor: 'background.paper',
        borderRadius: { xs: 0, md: 3 },
        width: '100%',
        margin: 0,
        maxHeight: '80vh',
      },
    },
  },
};

const GOLA_COMMON_MODAL_PROPS: ModalProps = {
  maxWidth: 'sm' as const,
  fullWidth: true,
  slotProps: {
    paper: {
      sx: {
        backgroundColor: 'neutral.700',
        margin: '20px',
        border: '1px solid',
        borderColor: 'neutral.100',
        borderRadius: '10px',
      },
    },
  },
};

export const SKINNED_COMMON_MODAL_PROPS: Record<string, ModalProps> = {
  [SKIN.BET365]: BET365_COMMON_MODAL_PROPS,
  [SKIN.GOLA]: GOLA_COMMON_MODAL_PROPS,
};
